<template>
  <div>
    <Catcher v-if="isCatcher" />
    <Dice v-else-if="isDice" />
    <Mines v-else-if="isMines" />
    <Crash v-else-if="isCrash" />
    <Frutto v-else-if="isFrutto" />
  </div>
</template>

<script>
import VueMixin from '../components/VueMixin'
import Catcher from '../components/Catcher'
import Dice from '../components/dice/Dice'
import Mines from '../components/mines/Mines'
import Crash from '../components/crash/Crash'
import Frutto from '../components/frutto/Frutto'

export default {
  components: {
    Crash, Mines, Dice, Catcher, Frutto
  },
  mixins: [VueMixin],
  data () {
    return {
    }
  },
  computed: {
    isCatcher () {
      return String(this.$route.params.game) === '1'
    },
    isDice () {
      return String(this.$route.params.game) === '2'
    },
    isMines () {
      return String(this.$route.params.game) === '3'
    },
    isCrash () {
      return String(this.$route.params.game) === '4'
    },
    isFrutto () {
      return String(this.$route.params.game) === '5'
    }
  },
  mounted () {
    if (this.isCatcher) this.$emit('title_changed', 'Catcher')
    else if (this.isDice) this.$emit('title_changed', 'Dice')
    else if (this.isMines) this.$emit('title_changed', 'Mines')
    else if (this.isCrash) this.$emit('title_changed', 'Crash')
    else if (this.isFrutto) this.$emit('title_changed', 'Frutto')
  },
  methods: {
  }
}
</script>
